import { POST_ACCOUNT_SUCCESS } from 'stash/actions/api';
import { GRAPHQL_GET_ACCOUNTS_SUCCESS } from 'stash/actions/apolloGraphql';
import { SET_MULTI_AUTOSTASH, SET_STASH_BANK } from 'stash/actions';

export const accountsMap = {
	PERSONAL_BROKERAGE: {
		typeEnum: 'personalBrokerage',
		amount: 50,
		frequency: 'weekly',
		order: 0,
	},
	TRADITIONAL_IRA: {
		typeEnum: 'traditionalIra',
		amount: 50,
		frequency: 'weekly',
		order: 1,
	},
	ROTH_IRA: {
		typeEnum: 'rothIra',
		amount: 50,
		frequency: 'weekly',
		order: 2,
	},
	BANK: {
		typeEnum: 'stashBank',
		amount: 30,
		frequency: 'weekly',
		order: 3,
	},
};

export const bankAccount = {
	id: null,
	type: 'BANK',
	typeEnum: accountsMap['BANK'].typeEnum,
	title: 'Stash banking',
	amount: accountsMap['BANK'].amount,
	frequency: accountsMap['BANK'].frequency,
	order: accountsMap['BANK'].order,
};

export const getAccountToFund = (account) => {
	const accountMapping = accountsMap[account.type];

	return {
		id: account.id,
		type: account.type,
		typeEnum: accountMapping.typeEnum,
		title: account.title,
		amount: accountMapping.amount,
		frequency: accountMapping.frequency,
		order: accountMapping.order,
	};
};

export const getAccountsToFund = (accounts) => {
	const accountsValue = Object.values(accounts);

	const hasInvestAccount =
		accountsValue.findIndex((account) => {
			return account.type === 'PERSONAL_BROKERAGE';
		}) > -1;

	const initialAccounts = hasInvestAccount
		? {
				stashBank: bankAccount,
		  }
		: {};

	return accountsValue.length
		? accountsValue.reduce((acc, account) => {
				const accountMapping = accountsMap[account.type];

				return accountMapping && accountMapping.typeEnum
					? {
							...acc,
							[accountMapping.typeEnum]: getAccountToFund(account),
					  }
					: acc;
		  }, initialAccounts)
		: {};
};

export const updateAccountsToFund = (accountsToFund, accountData) => {
	const accountsValue = Object.values(accountsToFund);

	return accountsValue.reduce((acc, account) => {
		const accountMapping = accountsMap[account.type];

		return accountMapping
			? {
					...acc,
					[accountMapping.typeEnum]: {
						...accountsToFund[accountMapping.typeEnum],
						amount: accountData[`${accountMapping.typeEnum}`].amount,
						frequency: accountData[`${accountMapping.typeEnum}`].frequency,
					},
			  }
			: acc;
	}, {});
};

export const getSortedAccounts = (accountsToFund) => {
	return Object.values(accountsToFund)
		.sort((a, b) => {
			return a.order - b.order;
		})
		.map((account) => account.typeEnum);
};

export const initState = {
	accountsToFund: {},
	order: [],
};

export const multiFunding = (state = initState, action) => {
	let accountsToFund = null;
	switch (action.type) {
		case SET_MULTI_AUTOSTASH:
			return {
				...state,
				accountsToFund: updateAccountsToFund(state.accountsToFund, action.data),
			};

		case SET_STASH_BANK:
			return {
				...state,
				accountsToFund: {
					...state.accountsToFund,
					stashBank: {
						...state.accountsToFund.stashBank,
						...action.data,
					},
				},
			};

		case POST_ACCOUNT_SUCCESS:
			accountsToFund = {
				...state.accountsToFund,
				...getAccountsToFund([action.response.account]),
			};

			return {
				...state,
				accountsToFund: {
					...state.accountsToFund,
					...accountsToFund,
				},
				order: getSortedAccounts(accountsToFund),
			};

		case GRAPHQL_GET_ACCOUNTS_SUCCESS:
			accountsToFund = getAccountsToFund(action.response.accounts);

			return {
				...state,
				accountsToFund,
				order: getSortedAccounts(accountsToFund),
			};

		default:
			return state;
	}
};

export default multiFunding;
